export const countries = [
  {
    code: "AF",
    name: "Afghanistan",
    de: "Afghanistan",
    fr: "Afghanistan",
    es: "Afganistán",
    pt: "Afeganistão",
  },
  {
    code: "AL",
    name: "Albania",
    de: "Albanien",
    fr: "Albanie",
    es: "Albania",
    pt: "Albânia",
  },
  {
    code: "DZ",
    name: "Algeria",
    de: "Algerien",
    fr: "Algérie",
    es: "Argelia",
    pt: "Argélia",
  },
  {
    code: "AR",
    name: "Argentina",
    de: "Argentinien",
    fr: "Argentine",
    es: "Argentina",
    pt: "Argentina",
  },
  {
    code: "AM",
    name: "Armenia",
    de: "Armenien",
    fr: "Arménie",
    es: "Armenia",
    pt: "Arménia",
  },
  {
    code: "AU",
    name: "Australia",
    de: "Australien",
    fr: "Australie",
    es: "Australia",
    pt: "Austrália",
  },
  {
    code: "AT",
    name: "Austria",
    de: "Österreich",
    fr: "Autriche",
    es: "Austria",
    pt: "Áustria",
  },
  {
    code: "AZ",
    name: "Azerbaijan",
    de: "Aserbaidschan",
    fr: "Azerbaïdjan",
    es: "Azerbaiyán",
    pt: "Azerbaijão",
  },
  {
    code: "BH",
    name: "Bahrain",
    de: "Bahrain",
    fr: "Bahreïn",
    es: "Baréin",
    pt: "Barém",
  },
  {
    code: "BD",
    name: "Bangladesh",
    de: "Bangladesch",
    fr: "Bangladesh",
    es: "Bangladés",
    pt: "Bangladesh",
  },
  {
    code: "BY",
    name: "Belarus",
    de: "Belarus",
    fr: "Biélorussie",
    es: "Bielorrusia",
    pt: "Bielorrússia",
  },
  {
    code: "BE",
    name: "Belgium",
    de: "Belgien",
    fr: "Belgique",
    es: "Bélgica",
    pt: "Bélgica",
  },
  {
    code: "BZ",
    name: "Belize",
    de: "Belize",
    fr: "Belize",
    es: "Belice",
    pt: "Belize",
  },
  {
    code: "BO",
    name: "Bolivia",
    de: "Bolivien",
    fr: "Bolivie",
    es: "Bolivia",
    pt: "Bolívia",
  },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    de: "Bosnien und Herzegowina",
    fr: "Bosnie-Herzégovine",
    es: "Bosnia y Herzegovina",
    pt: "Bósnia e Herzegovina",
  },
  {
    code: "BR",
    name: "Brazil",
    de: "Brasilien",
    fr: "Brésil",
    es: "Brasil",
    pt: "Brasil",
  },
  {
    code: "BG",
    name: "Bulgaria",
    de: "Bulgarien",
    fr: "Bulgarie",
    es: "Bulgaria",
    pt: "Bulgária",
  },
  {
    code: "KH",
    name: "Cambodia",
    de: "Kambodscha",
    fr: "Cambodge",
    es: "Camboya",
    pt: "Camboja",
  },
  {
    code: "CM",
    name: "Cameroon",
    de: "Kamerun",
    fr: "Cameroun",
    es: "Camerún",
    pt: "Camarões",
  },
  {
    code: "CA",
    name: "Canada",
    de: "Kanada",
    fr: "Canada",
    es: "Canadá",
    pt: "Canadá",
  },
  {
    code: "CL",
    name: "Chile",
    de: "Chile",
    fr: "Chili",
    es: "Chile",
    pt: "Chile",
  },
  {
    code: "CN",
    name: "China",
    de: "China",
    fr: "Chine",
    es: "China",
    pt: "China",
  },
  {
    code: "CO",
    name: "Colombia",
    de: "Kolumbien",
    fr: "Colombie",
    es: "Colombia",
    pt: "Colômbia",
  },
  {
    code: "CR",
    name: "Costa Rica",
    de: "Costa Rica",
    fr: "Costa Rica",
    es: "Costa Rica",
    pt: "Costa Rica",
  },
  {
    code: "HR",
    name: "Croatia",
    de: "Kroatien",
    fr: "Croatie",
    es: "Croacia",
    pt: "Croácia",
  },
  { code: "CU", name: "Cuba", de: "Kuba", fr: "Cuba", es: "Cuba", pt: "Cuba" },
  {
    code: "CY",
    name: "Cyprus",
    de: "Zypern",
    fr: "Chypre",
    es: "Chipre",
    pt: "Chipre",
  },
  {
    code: "CZ",
    name: "Czech Republic",
    de: "Tschechien",
    fr: "République tchèque",
    es: "República Checa",
    pt: "República Checa",
  },
  {
    code: "DK",
    name: "Denmark",
    de: "Dänemark",
    fr: "Danemark",
    es: "Dinamarca",
    pt: "Dinamarca",
  },
  {
    code: "DO",
    name: "Dominican Republic",
    de: "Dominikanische Republik",
    fr: "République dominicaine",
    es: "República Dominicana",
    pt: "República Dominicana",
  },
  {
    code: "EC",
    name: "Ecuador",
    de: "Ecuador",
    fr: "Équateur",
    es: "Ecuador",
    pt: "Equador",
  },
  {
    code: "EG",
    name: "Egypt",
    de: "Ägypten",
    fr: "Égypte",
    es: "Egipto",
    pt: "Egito",
  },
  {
    code: "SV",
    name: "El Salvador",
    de: "El Salvador",
    fr: "Salvador",
    es: "El Salvador",
    pt: "El Salvador",
  },
  {
    code: "EE",
    name: "Estonia",
    de: "Estland",
    fr: "Estonie",
    es: "Estonia",
    pt: "Estónia",
  },
  {
    code: "ET",
    name: "Ethiopia",
    de: "Äthiopien",
    fr: "Éthiopie",
    es: "Etiopía",
    pt: "Etiópia",
  },
  {
    code: "FI",
    name: "Finland",
    de: "Finnland",
    fr: "Finlande",
    es: "Finlandia",
    pt: "Finlândia",
  },
  {
    code: "FR",
    name: "France",
    de: "Frankreich",
    fr: "France",
    es: "Francia",
    pt: "França",
  },
  {
    code: "GE",
    name: "Georgia",
    de: "Georgien",
    fr: "Géorgie",
    es: "Georgia",
    pt: "Geórgia",
  },
  {
    code: "DE",
    name: "Germany",
    de: "Deutschland",
    fr: "Allemagne",
    es: "Alemania",
    pt: "Alemanha",
  },
  {
    code: "GH",
    name: "Ghana",
    de: "Ghana",
    fr: "Ghana",
    es: "Ghana",
    pt: "Gana",
  },
  {
    code: "GR",
    name: "Greece",
    de: "Griechenland",
    fr: "Grèce",
    es: "Grecia",
    pt: "Grécia",
  },
  {
    code: "GT",
    name: "Guatemala",
    de: "Guatemala",
    fr: "Guatemala",
    es: "Guatemala",
    pt: "Guatemala",
  },
  {
    code: "HN",
    name: "Honduras",
    de: "Honduras",
    fr: "Honduras",
    es: "Honduras",
    pt: "Honduras",
  },
  {
    code: "HK",
    name: "Hong Kong",
    de: "Hongkong",
    fr: "Hong Kong",
    es: "Hong Kong",
    pt: "Hong Kong",
  },
  {
    code: "HU",
    name: "Hungary",
    de: "Ungarn",
    fr: "Hongrie",
    es: "Hungría",
    pt: "Hungria",
  },
  {
    code: "IS",
    name: "Iceland",
    de: "Island",
    fr: "Islande",
    es: "Islandia",
    pt: "Islândia",
  },
  {
    code: "IN",
    name: "India",
    de: "Indien",
    fr: "Inde",
    es: "India",
    pt: "Índia",
  },
  {
    code: "ID",
    name: "Indonesia",
    de: "Indonesien",
    fr: "Indonésie",
    es: "Indonesia",
    pt: "Indonésia",
  },
  { code: "IR", name: "Iran", de: "Iran", fr: "Iran", es: "Irán", pt: "Irão" },
  {
    code: "IQ",
    name: "Iraq",
    de: "Irak",
    fr: "Irak",
    es: "Irak",
    pt: "Iraque",
  },
  {
    code: "IE",
    name: "Ireland",
    de: "Irland",
    fr: "Irlande",
    es: "Irlanda",
    pt: "Irlanda",
  },
  {
    code: "IL",
    name: "Israel",
    de: "Israel",
    fr: "Israël",
    es: "Israel",
    pt: "Israel",
  },
  {
    code: "IT",
    name: "Italy",
    de: "Italien",
    fr: "Italie",
    es: "Italia",
    pt: "Itália",
  },
  {
    code: "JM",
    name: "Jamaica",
    de: "Jamaika",
    fr: "Jamaïque",
    es: "Jamaica",
    pt: "Jamaica",
  },
  {
    code: "JP",
    name: "Japan",
    de: "Japan",
    fr: "Japon",
    es: "Japón",
    pt: "Japão",
  },
  {
    code: "JO",
    name: "Jordan",
    de: "Jordanien",
    fr: "Jordanie",
    es: "Jordania",
    pt: "Jordânia",
  },
  {
    code: "KZ",
    name: "Kazakhstan",
    de: "Kasachstan",
    fr: "Kazakhstan",
    es: "Kazajistán",
    pt: "Cazaquistão",
  },
  {
    code: "KE",
    name: "Kenya",
    de: "Kenia",
    fr: "Kenya",
    es: "Kenia",
    pt: "Quénia",
  },
  {
    code: "KW",
    name: "Kuwait",
    de: "Kuwait",
    fr: "Koweït",
    es: "Kuwait",
    pt: "Kuwait",
  },
  {
    code: "LV",
    name: "Latvia",
    de: "Lettland",
    fr: "Lettonie",
    es: "Letonia",
    pt: "Letónia",
  },
  {
    code: "LB",
    name: "Lebanon",
    de: "Libanon",
    fr: "Liban",
    es: "Líbano",
    pt: "Líbano",
  },
  {
    code: "LY",
    name: "Libya",
    de: "Libyen",
    fr: "Libye",
    es: "Libia",
    pt: "Líbia",
  },
  {
    code: "LT",
    name: "Lithuania",
    de: "Litauen",
    fr: "Lituanie",
    es: "Lituania",
    pt: "Lituânia",
  },
  {
    code: "LU",
    name: "Luxembourg",
    de: "Luxemburg",
    fr: "Luxembourg",
    es: "Luxemburgo",
    pt: "Luxemburgo",
  },
  {
    code: "MY",
    name: "Malaysia",
    de: "Malaysia",
    fr: "Malaisie",
    es: "Malasia",
    pt: "Malásia",
  },
  {
    code: "MV",
    name: "Maldives",
    de: "Malediven",
    fr: "Maldives",
    es: "Maldivas",
    pt: "Maldivas",
  },
  {
    code: "MT",
    name: "Malta",
    de: "Malta",
    fr: "Malte",
    es: "Malta",
    pt: "Malta",
  },
  {
    code: "MX",
    name: "Mexico",
    de: "Mexiko",
    fr: "Mexique",
    es: "México",
    pt: "México",
  },
  {
    code: "MD",
    name: "Moldova",
    de: "Moldau",
    fr: "Moldavie",
    es: "Moldavia",
    pt: "Moldávia",
  },
  {
    code: "MC",
    name: "Monaco",
    de: "Monaco",
    fr: "Monaco",
    es: "Mónaco",
    pt: "Mónaco",
  },
  {
    code: "MA",
    name: "Morocco",
    de: "Marokko",
    fr: "Maroc",
    es: "Marruecos",
    pt: "Marrocos",
  },
  {
    code: "NP",
    name: "Nepal",
    de: "Nepal",
    fr: "Népal",
    es: "Nepal",
    pt: "Nepal",
  },
  {
    code: "NL",
    name: "Netherlands",
    de: "Niederlande",
    fr: "Pays-Bas",
    es: "Países Bajos",
    pt: "Países Baixos",
  },
  {
    code: "NZ",
    name: "New Zealand",
    de: "Neuseeland",
    fr: "Nouvelle-Zélande",
    es: "Nueva Zelanda",
    pt: "Nova Zelândia",
  },
  {
    code: "NI",
    name: "Nicaragua",
    de: "Nicaragua",
    fr: "Nicaragua",
    es: "Nicaragua",
    pt: "Nicarágua",
  },
  {
    code: "NG",
    name: "Nigeria",
    de: "Nigeria",
    fr: "Nigeria",
    es: "Nigeria",
    pt: "Nigéria",
  },
  {
    code: "NO",
    name: "Norway",
    de: "Norwegen",
    fr: "Norvège",
    es: "Noruega",
    pt: "Noruega",
  },
  { code: "OM", name: "Oman", de: "Oman", fr: "Oman", es: "Omán", pt: "Omã" },
  {
    code: "PK",
    name: "Pakistan",
    de: "Pakistan",
    fr: "Pakistan",
    es: "Pakistán",
    pt: "Paquistão",
  },
  {
    code: "PA",
    name: "Panama",
    de: "Panama",
    fr: "Panama",
    es: "Panamá",
    pt: "Panamá",
  },
  {
    code: "PY",
    name: "Paraguay",
    de: "Paraguay",
    fr: "Paraguay",
    es: "Paraguay",
    pt: "Paraguai",
  },
  { code: "PE", name: "Peru", de: "Peru", fr: "Pérou", es: "Perú", pt: "Peru" },
  {
    code: "PH",
    name: "Philippines",
    de: "Philippinen",
    fr: "Philippines",
    es: "Filipinas",
    pt: "Filipinas",
  },
  {
    code: "PL",
    name: "Poland",
    de: "Polen",
    fr: "Pologne",
    es: "Polonia",
    pt: "Polónia",
  },
  {
    code: "PT",
    name: "Portugal",
    de: "Portugal",
    fr: "Portugal",
    es: "Portugal",
    pt: "Portugal",
  },
  {
    code: "QA",
    name: "Qatar",
    de: "Katar",
    fr: "Qatar",
    es: "Catar",
    pt: "Catar",
  },
  {
    code: "RO",
    name: "Romania",
    de: "Rumänien",
    fr: "Roumanie",
    es: "Rumanía",
    pt: "Roménia",
  },
  {
    code: "RU",
    name: "Russia",
    de: "Russland",
    fr: "Russie",
    es: "Rusia",
    pt: "Rússia",
  },
  {
    code: "SA",
    name: "Saudi Arabia",
    de: "Saudi-Arabien",
    fr: "Arabie saoudite",
    es: "Arabia Saudita",
    pt: "Arábia Saudita",
  },
  {
    code: "RS",
    name: "Serbia",
    de: "Serbien",
    fr: "Serbie",
    es: "Serbia",
    pt: "Sérvia",
  },
  {
    code: "SG",
    name: "Singapore",
    de: "Singapur",
    fr: "Singapour",
    es: "Singapur",
    pt: "Singapura",
  },
  {
    code: "SK",
    name: "Slovakia",
    de: "Slowakei",
    fr: "Slovaquie",
    es: "Eslovaquia",
    pt: "Eslováquia",
  },
  {
    code: "SI",
    name: "Slovenia",
    de: "Slowenien",
    fr: "Slovénie",
    es: "Eslovenia",
    pt: "Eslovénia",
  },
  {
    code: "ZA",
    name: "South Africa",
    de: "Südafrika",
    fr: "Afrique du Sud",
    es: "Sudáfrica",
    pt: "África do Sul",
  },
  {
    code: "KR",
    name: "South Korea",
    de: "Südkorea",
    fr: "Corée du Sud",
    es: "Corea del Sur",
    pt: "Coreia do Sul",
  },
  {
    code: "ES",
    name: "Spain",
    de: "Spanien",
    fr: "Espagne",
    es: "España",
    pt: "Espanha",
  },
  {
    code: "LK",
    name: "Sri Lanka",
    de: "Sri Lanka",
    fr: "Sri Lanka",
    es: "Sri Lanka",
    pt: "Sri Lanka",
  },
  {
    code: "SE",
    name: "Sweden",
    de: "Schweden",
    fr: "Suède",
    es: "Suecia",
    pt: "Suécia",
  },
  {
    code: "CH",
    name: "Switzerland",
    de: "Schweiz",
    fr: "Suisse",
    es: "Suiza",
    pt: "Suíça",
  },
  {
    code: "TW",
    name: "Taiwan",
    de: "Taiwan",
    fr: "Taïwan",
    es: "Taiwán",
    pt: "Taiwan",
  },
  {
    code: "TZ",
    name: "Tanzania",
    de: "Tansania",
    fr: "Tanzanie",
    es: "Tanzania",
    pt: "Tanzânia",
  },
  {
    code: "TH",
    name: "Thailand",
    de: "Thailand",
    fr: "Thaïlande",
    es: "Tailandia",
    pt: "Tailândia",
  },
  {
    code: "TN",
    name: "Tunisia",
    de: "Tunesien",
    fr: "Tunisie",
    es: "Túnez",
    pt: "Tunísia",
  },
  {
    code: "TR",
    name: "Turkey",
    de: "Türkei",
    fr: "Turquie",
    es: "Turquía",
    pt: "Turquia",
  },
  {
    code: "UA",
    name: "Ukraine",
    de: "Ukraine",
    fr: "Ukraine",
    es: "Ucrania",
    pt: "Ucrânia",
  },
  {
    code: "AE",
    name: "United Arab Emirates",
    de: "Vereinigte Arabische Emirate",
    fr: "Émirats arabes unis",
    es: "Emiratos Árabes Unidos",
    pt: "Emirados Árabes Unidos",
  },
  {
    code: "GB",
    name: "United Kingdom",
    de: "Vereinigtes Königreich",
    fr: "Royaume-Uni",
    es: "Reino Unido",
    pt: "Reino Unido",
  },
  {
    code: "US",
    name: "United States",
    de: "Vereinigte Staaten",
    fr: "États-Unis",
    es: "Estados Unidos",
    pt: "Estados Unidos",
  },
  {
    code: "UY",
    name: "Uruguay",
    de: "Uruguay",
    fr: "Uruguay",
    es: "Uruguay",
    pt: "Uruguai",
  },
  {
    code: "UZ",
    name: "Uzbekistan",
    de: "Usbekistan",
    fr: "Ouzbékistan",
    es: "Uzbekistán",
    pt: "Uzbequistão",
  },
  {
    code: "VE",
    name: "Venezuela",
    de: "Venezuela",
    fr: "Venezuela",
    es: "Venezuela",
    pt: "Venezuela",
  },
  {
    code: "VN",
    name: "Vietnam",
    de: "Vietnam",
    fr: "Viêt Nam",
    es: "Vietnam",
    pt: "Vietname",
  },
  {
    code: "YE",
    name: "Yemen",
    de: "Jemen",
    fr: "Yémen",
    es: "Yemen",
    pt: "Iémen",
  },
  {
    code: "ZM",
    name: "Zambia",
    de: "Sambia",
    fr: "Zambie",
    es: "Zambia",
    pt: "Zâmbia",
  },
  {
    code: "ZW",
    name: "Zimbabwe",
    de: "Simbabwe",
    fr: "Zimbabwe",
    es: "Zimbabue",
    pt: "Zimbabué",
  },
];

export const getCountryName = (
  code: string,
  language: "en" | "de" | "fr" | "es" | "pt" = "en",
): string => {
  const country = countries.find((c) => c.code === code);
  if (!country) return code;

  switch (language) {
    case "de":
      return country.de;
    case "fr":
      return country.fr;
    case "es":
      return country.es;
    case "pt":
      return country.pt;
    default:
      return country.name;
  }
};

export const getCountriesByLanguage = (
  language: "en" | "de" | "fr" | "es" | "pt" = "en",
) => {
  return countries
    .map((c) => ({
      code: c.code,
      name: getCountryName(c.code, language),
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};
